import React from 'react';
import { useAuth } from '@contexts/AuthContext';
import { ROLE_GROUPS } from '@app-types';
import { hasRole } from '@utils/permissionUtils';
import AssessmentDetailPage from '@pages/AssessmentDetailPage';
import AssessmentDetailAdminPage from '@pages/AssessmentDetailAdminPage';

/**
 * Admin keeps the high-level assessment page (no framework).
 * Program Lead and multi-role users without Admin use the assessor details page so they
 * can see and evaluate processes (ADO-1195, ADO-1200).
 */
const AssessmentDetailSelector: React.FC = () => {
  const { user } = useAuth();

  if (hasRole(user, ROLE_GROUPS.ADMIN_ONLY)) {
    return <AssessmentDetailAdminPage />;
  }

  return <AssessmentDetailPage />;
};

export default AssessmentDetailSelector;
